import { useTranslation } from 'react-i18next'

import { helpers, shipmentStatuses, Text } from '@reveni-io/reveni-ui'

import { getNormalizedTrackingStatusMessage } from '@/parcels/pages/ParcelDetailPage/helpers'

import { getStylesByStatus } from './helpers'
import * as Styles from './styles'

const StatusTooltip = ({
  status,
  createdAt,
  packedAt,
  readyAt,
  shippedAt,
  outForDeliveryAt,
  normalizedTrackingStatus,
}) => {
  const { t } = useTranslation()
  const styles = getStylesByStatus()[status]

  const dateByStatus = {
    [shipmentStatuses.requested]: createdAt,
    [shipmentStatuses.packed]: packedAt,
    [shipmentStatuses.ready]: readyAt,
    [shipmentStatuses.shipped]: shippedAt,
    [shipmentStatuses.out_for_delivery]: outForDeliveryAt,
  }

  const title = getNormalizedTrackingStatusMessage(status, normalizedTrackingStatus)
  const time = dateByStatus[status] ? helpers.getRelativeTime(dateByStatus[status], t) : undefined

  if (!title) return null

  return (
    <Styles.MainContainer backgroundColor={styles?.backgroundColor}>
      <Text type="bodySBold" color={styles?.colorTitle} customStyles={{ textAlign: 'center' }}>
        &quot;{t(title)}&quot;
      </Text>
      {time && (
        <Text type="bodyXSRegular" color={styles?.colorHour}>
          {time}
        </Text>
      )}
    </Styles.MainContainer>
  )
}

export default StatusTooltip
